import React from "react";
import image1 from "../../assets/images/png/corporate-films.png";
import image2 from "../../assets/images/png/corporate-digital.png";

const CAPABILITIES = [
  {
    title: "Corporate Films",
    desc: "Purpose-driven films that represent your organization's identity, values, and vision. (Company Profiles, Industrial Films, CSR).",
    image: image1,
  },
  {
    title: "Corporate Digital",
    desc: "Strategic digital marketing solutions focused on brand positioning and measurable growth (LinkedIn, Performance, Content).",
    image: image2,
  },
  {
    title: "Corporate Events",
    desc: "Professional media coverage for conferences, launches, and corporate programs.",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
];

const CorporateCapabilities = () => {
  return (
    <section
      className="corporate_section"
      style={{ backgroundColor: "var(--secondary-dark)" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <h2
            className="display-5 capabilities_title fw-bold"
            style={{ color: "var(--white)" }}
          >
            What We Do
          </h2>
        </div>

        <div className="row g-4">
          {CAPABILITIES.map((item) => (
            <div className="col-lg-4" key={item.title}>
              <div className="cinematic-card">
                <div
                  className="cinematic-bg"
                  style={{ backgroundImage: `url('${item.image}')` }}
                />
                <div className="cinematic-overlay" />
                <div className="cinematic-content">
                  <h3 className="h4 fw-bold capabilities_card_title text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="cinematic-desc m-0">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorporateCapabilities;
